import { Action } from "@reduxjs/toolkit";
import { HomeState, Role } from "./types";
import { isType } from "typescript-fsa";
import { homeActions } from "./actions";

const initialState: HomeState = {
  hot_property: [],
  inquiry_form: null,
  image: null,
};

export function HomeReducer(state = initialState, action: Action): HomeState {
  if (isType(action, homeActions.hotPropertyies.done)) {
    return {
      ...state,
      hot_property: action.payload.result.data.map((data) => ({
        id: data.id,
        property_code: data.property_code,
        property_name: data.property_name,
        property_category: data.property_category,
        property_type: data.property_type,
        property_status: data.property_status,
        property_status_display: data.property_status_display,
        is_available: data.is_available,
        sold_rented_at: data.sold_rented_at,
        owner: data.owner,
        city: data.city,
        district: data.district,
        commune: data.commune,
        price: data.price,
        size: data.size,
        land_area: data.land_area,
        bedrooms: data.bedrooms,
        bathrooms: data.bathrooms,
        popular_place: data.popular_place,
        features: data.features,
        youtube_link: data.youtube_link,
        google_map_link: data.google_map_link,
        description: data.description,
        thumbnail_image: data.thumbnail_image,
        property_images: data.property_images,
        is_hot: data.is_hot,
        created_at: data.created_at,
      })),
    };
  }
  if (isType(action, homeActions.homepageImage.done)) {
    return {
      ...state,
      image: action.payload.result,
    };
  }
  if (isType(action, homeActions.inquiryForm.done)) {
    const data = action.payload.result;
    return {
      ...state,
      inquiry_form: {
        inquiry_type: data.inquiry_type,
        role: data.role as Role,
        last_name: data.last_name,
        first_name: data.first_name,
        phone_number: data.phone_number,
        email_address: data.email_address,
        description: data.description,
      },
    };
  }

  if (isType(action, homeActions.resetToInitialState)) {
    return initialState;
  }
  return state;
}
